<template>
    <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
        style="overflow: hidden;">
        <div class="m-portlet m-portlet--mobile">
            <SearchTitle label='出科管理' url='/cycle/out/outmanage'></SearchTitle>
            <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                <div class="m-form m-form--label-align-right">
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">管理单元：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.secretarysec" filterable placeholder="全部"
                                    @change="ManageSecChange">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in managesecOptions" :key="item.DictItemID"
                                        :label="item.DictItemName" :value="item.DictItemID">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">轮转科室：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.section" filterable placeholder="全部">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in secOptions" :key="item.DictItemID"
                                        :label="item.DictItemName" :value="item.DictItemID">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
                    <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
                    <ZPGLSearchDictItemSelect v-model='condition.specialty' label='专业'
                        :dictid='this.$utils.DictEnum.specialty'>
                    </ZPGLSearchDictItemSelect>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">出科时间：</label>
                            </div>
                            <div class="m-form__control">
                                <el-date-picker v-model="condition.outdate" type="month" placeholder="出科时间"
                                    value-format="yyyy-MM">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">出科状态：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.examtype" filterable placeholder="全部">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in examTypeOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">审核状态：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.outstatus" filterable placeholder="全部">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in oaStatusOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">考核时间：</label>
                            </div>
                            <div class="m-form__control">
                                <el-date-picker v-model="condition.examdate" type="date" placeholder="考核时间"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <ZPGLSearchDictItemSelect v-model='condition.examtime' label='时间段'
                        :dictid='this.$utils.DictEnum.examtime'>
                    </ZPGLSearchDictItemSelect>
                </div>
                <div style="clear: both;"></div>
                <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
                    <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
                    <!--      <el-button type="primary" icon="el-icon-search" @click="DelayOutApply()">延期人员管理</el-button> -->
                    <el-button type="primary" icon="el-icon-download" @click="Out">导出</el-button>
                </div>
                <!--end: Search Form -->
                <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                    <!--begin: Datatable -->
                    <el-table v-loading="loading" ref="fixedTable" :data="tableData" style="width: 100%" size="medium">
                        <el-table-column>
                            <template slot="header">
                                姓名<br>工号
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.CPStuName }}<br>{{ scope.row.CPStuNo }}
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <template slot="header">
                                专业<br>用户类型
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.StuSpecName }}<br>{{ scope.row.StuUserTypeName }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="CPManageSecName" label="管理单元">
                        </el-table-column>
                        <el-table-column prop="CPSecName" label="轮转科室">
                        </el-table-column>
                        <el-table-column label="考核时间" width="200">
                            <template slot-scope="scope">
                                <div v-if="scope.row.ExamType == '1'">
                                    {{ scope.row.ExamDate | formatFullDate }} <br> {{ scope.row.ExamTimeName }}
                                </div>
                                <div v-if="scope.row.ExamType == '2'">
                                    -
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ProjectName" label="考核项" width="240">
                        </el-table-column>
                        <el-table-column width="240">
                            <template slot="header">
                                考官<br>工号
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.TecList }}<br>{{ scope.row.TecNoList }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="轮转时间" width="240">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
              </template>
            </el-table-column> -->
                        <el-table-column label="出科状态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.ExamType == '0'">
                                    {{ scope.row.ExamTypeName }}
                                </div>
                                <div v-if="scope.row.ExamType == '1'">
                                    <span style="color: #409EFF;">{{ scope.row.ExamTypeName }}</span>
                                </div>
                                <div v-if="scope.row.ExamType == '2'">
                                    <span style="color: #F56C6C;">{{ scope.row.ExamTypeName }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="考试状态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.Remark1 == '1' && scope.row.ScoreStatus == '0'">
                                    <span style="color: #409EFF;">考试中</span>
                                </div>
                                <div v-if="scope.row.Remark1 == '1' && scope.row.ScoreStatus == '1'">
                                    <span style="color: #67C23A;">已完成</span>
                                </div>
                                <div v-if="scope.row.Remark1 == '0'">
                                    <span style="color: #F56C6C;">未考试</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="评分状态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.ScoreStatus == '1'">
                                    <span style="color: #409EFF;">已评分</span>
                                </div>
                                <div v-if="scope.row.ScoreStatus == '0'">
                                    <span style="color: #F56C6C;">未评分</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="审核状态">
                            <template slot-scope="scope">
                                <div v-if="scope.row.OAStatus == null">
                                    -
                                </div>
                                <div v-if="scope.row.OAStatus == '1'">
                                    {{ scope.row.OAStatusName }}
                                </div>
                                <div v-if="scope.row.OAStatus == '2'">
                                    <span style="color: #409EFF;">{{ scope.row.OAStatusName }}</span>
                                </div>
                                <div v-if="scope.row.OAStatus == '3'">
                                    <span style="color: #F56C6C;">{{ scope.row.OAStatusName }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="180" fixed="right">
                            <template slot-scope="scope">
                                <div
                                    v-if="condition.rolelevel == 2 || condition.rolelevel == 3"> 
                                    <!-- 科秘书 || condition.rolelevel == 5 -->
                                    <div v-if="scope.row.ExamType == '0'">
                                        <!-- 未申报 -->
                                        <el-button type="text" size="medium" @click="OutAdd(scope.row)"
                                            v-if="scope.row.CPStatus > 1">申请出科
                                        </el-button>
                                        <!--  <el-button type="text" size="medium" @click="OutDelay(scope.row)" v-if="scope.row.CPStatus > 1">延期考核
                    </el-button> -->
                                        <el-button type="text" size="medium" disabled title="尚未入科，无法申请出科"
                                            v-if="scope.row.CPStatus == 1">
                                            申请出科</el-button>
                                        <!--   <el-button type="text" size="medium" disabled title="尚未入科，无法延期考核" v-if="scope.row.CPStatus == 1">
                      延期考核</el-button> -->
                                    </div>
                                    <div v-if="scope.row.OAStatus == '1'">
                                        <!-- 已申报 -->
                                        <el-button type="text" size="medium" @click="OutEdit(scope.row)">修改</el-button>
                                        <!--  <el-button type="text" size="medium" @click="OutDelay(scope.row)">延期考核
                    </el-button> -->
                                    </div>
                                    <div v-if="scope.row.ScoreStatus == '1'">
                                        <el-button type="text" v-if="scope.row.IsOSCE == '1'" size="medium"
                                            @click="ScoreInfo(scope.row)">
                                            评分记录</el-button>
                                    </div>
                                    <!-- <div v-if="scope.row.OAStatus=='2' && scope.row.ExamType=='1'">
                    <el-button type="text" size="medium" @click="OutDelay(scope.row)"
                      v-if="scope.row.ScoreStatus == 0 && scope.row.Remark1 != '1'">延期考核
                    </el-button>
                  </div> -->
                                    <div v-if="scope.row.OAStatus == '3'">
                                        <!-- 审核不通过 -->
                                        <el-button type="text" size="medium" @click="OutEdit(scope.row)">修改</el-button>
                                        <!-- <el-button type="text" size="medium" @click="OutDelay(scope.row)">延期考核
                    </el-button> -->
                                        <el-button type="text" size="medium" @click="OutAdd(scope.row)"
                                            v-if="scope.row.CPStatus > 1">申请出科
                                        </el-button>
                                    </div>
                                </div>
                                <div
                                    v-if="condition.rolelevel == 3 || condition.rolelevel == 4 || condition.rolelevel == 5">
                                    <!-- 管理员 -->
                                    <div v-if="scope.row.ExamType == '0'">
                                        <!-- 未申报 -->
                                        <span>-</span>
                                    </div>
                                    <div v-if="scope.row.ExamType != '1' && scope.row.OAStatus == '1'">
                                        <!-- 未审核 -->
                                        <span>-</span>
                                    </div>
                                    <div v-if="scope.row.OAStatus == '2' && scope.row.ExamType == '1'">
                                        <!-- 审核通过 -->
                                        <div v-if="scope.row.OAManageSec == '0'">
                                            <el-button type="text" v-if="scope.row.IsOSCE == '0'" size="medium"
                                                @click="Score(scope.row)">开始考核
                                            </el-button>
                                            <el-button type="text" v-if="scope.row.IsOSCE == '1'" size="medium"
                                                @click="ScoreInfo(scope.row)">
                                                评分记录</el-button>
                                        </div>
                                        <div v-if="scope.row.OAManageSec == '1'">
                                            <el-button type="text" size="medium"
                                                @click="ScoreInfo(scope.row)">评分记录</el-button>
                                        </div>
                                    </div>
                                    <div v-if="scope.row.OAStatus == '3'">
                                        <!-- 审核不通过 -->
                                        <span>-</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--end: Datatable -->
                    <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]"
                            :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
                            :total="condition.recordCount">
                        </el-pagination>
                    </div>
                    <el-dialog width="1000px" title="出科评分" :visible.sync="socreVisible">
                        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
                            :model="form">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="姓名:">
                                        {{ form.CPStuName }}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="轮转科室:">
                                        {{ form.CPSecName }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="轮转时间:">
                                        {{ form.CPDate }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="预约时间:">
                                        {{ form.OutApplyDate }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="考官1:">
                                        <el-select v-model="form.TecID1" filterable placeholder="请选择">
                                            <el-option label="请选择" value=""></el-option>
                                            <el-option v-for="item in tecOptions" :key="item.TecID"
                                                :label="item.TrueName" :value="item.TecID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="考官2:">
                                        <el-select v-model="form.TecID2" filterable placeholder="请选择">
                                            <el-option label="请选择" value=""></el-option>
                                            <el-option v-for="item in tecOptions" :key="item.TecID"
                                                :label="item.TrueName" :value="item.TecID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="考官3:">
                                        <el-select v-model="form.TecID3" filterable placeholder="请选择">
                                            <el-option label="请选择" value=""></el-option>
                                            <el-option v-for="item in tecOptions" :key="item.TecID"
                                                :label="item.TrueName" :value="item.TecID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="考核项目:">
                                        <el-select v-model="form.projectid" filterable placeholder="请选择">
                                            <el-option label="请选择" value=""></el-option>
                                            <el-option v-for="item in projectOptions" :key="item.ProjectID"
                                                :label="item.Extension2" :value="item.ProjectID">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="success" @click="ScoreSave()"
                                v-loading.fullscreen.lock="fullscreenLoading">确 认
                            </el-button>
                        </div>
                    </el-dialog>
                    <el-dialog width="30%" title="评分记录" :visible.sync="socreInfoVisible">
                        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
                            :model="infoform">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="姓名:">
                                        {{ infoform.CPStuName }}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="轮转科室:">
                                        {{ infoform.CPSecName }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="轮转时间:">
                                        {{ infoform.CPDate }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="考官1:">
                                        {{ infoform.TecName1 }}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="评分:">
                                        {{ infoform.tecscore1 }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="考官2:">
                                        {{ infoform.TecName2 }}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="评分:">
                                        {{ infoform.tecscore2 }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="考官3:">
                                        {{ infoform.TecName3 }}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="评分:">
                                        {{ infoform.tecscore3 }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="预约时间:">
                                        {{ infoform.OutApplyDate }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="考核科目:">
                                        {{ infoform.ProjectName }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="出科得分:">
                                        {{ infoform.tecstate == 0 ? '考核未完成' : infoform.outapplyscore }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="完成时间:">
                                        {{ infoform.downdate }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="考核地点:">
                                        {{ infoform.examaddress }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="审核状态:">
                                        <span v-if="infoform.checkstatus == 2" style="color:#67C23A">审核通过</span>
                                        <span v-if="infoform.checkstatus == 3" style="color:#F56C6C">审核不通过</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="审核意见:">
                                        {{ infoform.checkinfo }}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-dialog>
                    <el-dialog width="30%" :title="delaytitle" :visible.sync="delayVisible">
                        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
                            :model="delayform">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="延期原因:">
                                        <el-input v-model="delayform.delayreason"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="success" @click="SaveDelay()"
                                v-loading.fullscreen.lock="fullscreenLoading">保存
                            </el-button>
                        </div>
                    </el-dialog>
                    <el-dialog width="30%" :title="delaytitle" :visible.sync="delayeditVisible">
                        <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
                            :model="delayeditform">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="延期原因:">
                                        <el-input v-model="delayeditform.delayreason"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="success" @click="UpdateDelay()"
                                v-loading.fullscreen.lock="fullscreenLoading">保存
                            </el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OutManage',
    data() {
        return {
            condition: {
                token: '',
                username: '',
                rolelevel: '',
                secretarysec: '',
                section: '',
                truename: '',
                cardno: '',
                specialty: '',
                outdate: '',
                examtype: '',
                outstatus: '',
                pageSize: 10,
                currentPage: 1,
                recordCount: 0,
                firstSearch: true,
                viewtype: '1',
                examtime: ''
            },
            addressOption: ['技能培训中心', '儿外科'],
            form: {
                token: '',
                oaid: '',
                cpid: '',
                CPStuName: '',
                CPSecName: '',
                CPDate: '',
                TecOldID1: '',
                TecOldID2: '',
                TecOldID3: '',
                TecID1: '',
                TecID2: '',
                TecID3: '',
                TecName1: '',
                TecName2: '',
                TecName3: '',
                tecscore1: '0',
                tecscore2: '0',
                tecscore3: '0',
                projectid: '',
                OutApplyDate: '',
                outapplyscore: '0',
                downdate: '',
                examaddress: '技能培训中心',
                oastatus: '',
                checkinfo: ''
            },
            infoform: {
                oaid: '',
                cpid: '',
                CPStuName: '',
                CPSecName: '',
                CPDate: '',
                TecName1: '',
                TecName2: '',
                TecName3: '',
                tecscore1: '',
                tecscore2: '',
                tecscore3: '',
                ProjectName: '',
                OutApplyDate: '',
                outapplyscore: '',
                downdate: '',
                examaddress: '',
                checkstatus: '',
                checkinfo: '',
                tecstate: 1 //考核状态
            },
            projectOptions: [],
            searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyList',
            managesecOptions: [],
            secOptions: [],
            examTypeOptions: [{
                value: '0',
                label: '未申请'
            },
            {
                value: '1',
                label: '正常出科'
            },
            {
                value: '2',
                label: '延期考核'
            }
            ],
            oaStatusOptions: [{
                value: '1',
                label: '未审核'
            },
            {
                value: '2',
                label: '审核通过'
            },
            {
                value: '3',
                label: '审核不通过'
            }
            ],
            tableData: [],
            tecOptions: [],
            socreVisible: false,
            socreInfoVisible: false,
            loading: true,
            fullscreenLoading: false,
            delaytitle: '',
            delayVisible: false,
            delayeditVisible: false,
            delayform: {
                token: '',
                cpid: '',
                examtype: '2',
                delayreason: ''
            },
            delayeditform: {
                token: '',
                cpid: '',
                examtype: '2',
                delayreason: ''
            },
            outUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/OutListOut'
        }
    },
    filters: {
        formatDate(val) {
            var now = new Date(val)
            var y = now.getFullYear()
            var m = now.getMonth() + 1
            return y + '-' + (m < 10 ? '0' + m : m)
        },
        formatFullDate(val) {
            var now = new Date(val)
            var y = now.getFullYear()
            var m = now.getMonth() + 1
            var d = now.getDate()
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
        }
    },
    watch: {
        loading(newValue) {
            if (!newValue) {
                this.$nextTick(() => {
                    this.$refs.fixedTable.doLayout();
                });
            }
        }
    },
    methods: {
        DelayOutApply: function () {
            this.$router.push('/main/cycle/out/delayoutapplymanage')
        },
        OutDelay: function (row) {
            this.delayform.cpid = row.CPID
            this.delaytitle = row.CPStuName + '延迟考核申请'
            this.delayform.delayreason = ''
            this.delayVisible = true
        },
        SaveDelay: function () {
            if (this.delayform.delayreason == '') {
                this.$message({
                    message: '延期原因不能为空',
                    type: 'warning'
                })
                return
            }

            this.fullscreenLoading = true
            var that = this
            this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/AddOutApply', this.delayform)
                .then(res => {
                    if (res.data.Code === 0) {
                        that.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                        console.log('保存成功')
                        that.delayVisible = false
                        that.$refs.btnSearch.Search()
                    } else {
                        that.$message({
                            message: res.data.Msg + '，' + res.data.Data,
                            type: 'error'
                        })
                    }
                    that.fullscreenLoading = false
                })
                .catch(err => {
                    console.log(err)
                    that.$message({
                        message: '保存失败',
                        type: 'error'
                    })
                    that.fullscreenLoading = false
                })
        },
        UpdateDelay: function () {
            if (this.delayeditform.delayreason == '') {
                this.$message({
                    message: '延期原因不能为空',
                    type: 'warning'
                })
                return
            }

            this.fullscreenLoading = true
            var that = this
            this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/EditOutApply', this.delayeditform)
                .then(res => {
                    if (res.data.Code === 0) {
                        that.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                        console.log('保存成功')
                        that.delayeditVisible = false
                        that.$refs.btnSearch.Search()
                    } else {
                        that.$message({
                            message: res.data.Msg + '，' + res.data.Data,
                            type: 'error'
                        })
                    }
                    that.fullscreenLoading = false
                })
                .catch(err => {
                    console.log(err)
                    that.$message({
                        message: '保存失败',
                        type: 'error'
                    })
                    that.fullscreenLoading = false
                })
        },
        // 调整每页显示数
        handleCurrentChange: function (val) {
            this.condition.firstSearch = false
            this.condition.currentPage = val
            this.$refs.btnSearch.Search()
        },
        // 分页操作
        handleSizeChange: function (val) {
            this.condition.firstSearch = false
            this.condition.pageSize = val
            this.condition.currentPage = 1
            this.$refs.btnSearch.Search()
        },
        InputBlur: function (index) {
            if (index == 1) {
                if (parseFloat(this.form.tecscore1)) {
                    if (this.form.tecscore1 < 0) {
                        this.form.tecscore1 = 0
                    } else {
                        if (this.form.tecscore1 > 100) {
                            this.form.tecscore1 = 100
                        }
                    }
                } else {
                    this.form.tecscore1 = 0
                }
            } else if (index == 2) {
                if (parseFloat(this.form.tecscore2)) {
                    if (this.form.tecscore2 < 0) {
                        this.form.tecscore2 = 0
                    } else {
                        if (this.form.tecscore2 > 100) {
                            this.form.tecscore2 = 100
                        }
                    }
                } else {
                    this.form.tecscore2 = 0
                }
            } else if (index == 3) {
                if (parseFloat(this.form.tecscore3)) {
                    if (this.form.tecscore3 < 0) {
                        this.form.tecscore3 = 0
                    } else {
                        if (this.form.tecscore3 > 100) {
                            this.form.tecscore3 = 100
                        }
                    }
                } else {
                    this.form.tecscore3 = 0
                }
            }
        },
        OutAdd: function (row) {
            let that = this
            //判断是否在免形成性评价管理单元中
            let num = this.$utils.Url.OutNoMartDept.split(',').find(item => item == row.CPManageSec);
            let stepMark = num ? true : false;
            if (this.condition.rolelevel == 3 || this.condition.rolelevel == 5 || stepMark) {//管理员随便约
                that.$router.push({
                    name: 'OutAdd',
                    params: {
                        id: row.CPID,
                        managesec: row.CPManageSec,
                        cpmanagesecname: row.CPManageSecName //管理单元
                    }
                })
            } else {

                let args = {
                    cardno: row.CPStuNo,
                    cpbegindate: row.CPBeginDate.substring(0, 10),
                    cpenddate: row.CPEndDate.substring(0, 10)
                }
                //调用服务端接口，判断当前学员是否完成形成性评价
                this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/UserMarkCount', args, function (data) {
                    if (data.Data == 0) {
                        that.$message({
                            message: '该学员尚未完成形成性评价，请先完成形成性评价！',
                            type: 'error'
                        })
                    } else {
                        that.$router.push({
                            name: 'OutAdd',
                            params: {
                                id: row.CPID,
                                managesec: row.CPManageSec,
                                cpmanagesecname: row.CPManageSecName //管理单元
                            }
                        })
                    }
                }, null, null, null)
            }

            // this.$router.push({
            //     name: 'OutAdd',
            //     params: {
            //         id: row.CPID,
            //         managesec: row.CPManageSec,
            //         cpmanagesecname: row.CPManageSecName //管理单元
            //     }
            // })
        },
        OutEdit: function (row) {
            console.log(row)
            if (row.ExamType == 1) {
                this.$router.push({
                    name: 'OutEdit',
                    params: {
                        id: row.CPID,
                        managesec: row.CPManageSec,
                        cpmanagesecname: row.CPManageSecName //管理单元
                    }
                })
            } else {
                this.delayeditform.cpid = row.CPID
                this.delaytitle = row.CPStuName + '延迟考核申请'
                this.delayeditform.delayreason = row.DelayReason
                this.delayeditVisible = true
            }
        },
        DeleteOutApply: function (row) {
            this.$confirm('确定撤销 ' + row.CPStuName + ' 的出科申请?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true
                var that = this
                var args = {
                    token: this.form.token,
                    cpid: row.CPID
                }
                this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/DeleteOutApply', args)
                    .then(res => {
                        console.log(res.data)
                        if (res.data.Code === 0) {
                            that.$message({
                                message: '撤销成功',
                                type: 'success'
                            })
                            that.$refs.btnSearch.Search()
                        } else {
                            that.$message({
                                message: res.data.Msg + '，' + res.data.Error,
                                type: 'error'
                            })
                        }
                        that.fullscreenLoading = false
                    })
                    .catch(err => {
                        console.log(err)
                        that.$message({
                            message: '撤销失败',
                            type: 'error'
                        })
                        that.fullscreenLoading = false
                    })
            }).catch(() => { })
        },
        LoadManageSec: function () {
            var args = {
                token: this.condition.token,
                username: this.condition.username,
                rolelevel: this.condition.rolelevel
            }
            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function (data) {
                that.managesecOptions = data.Data
                that.$refs.btnSearch.Search()
            }, null, null, null)
        },
        ManageSecChange: function () {
            this.condition.section = ''
            this.secOptions = []
            this.LoadCPSec()
        },
        LoadCPSec: function () {
            var args = {
                token: this.condition.token,
                username: this.condition.username,
                rolelevel: this.condition.rolelevel,
                mamagesec: this.condition.secretarysec
            }
            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function (data) {
                that.secOptions = data.Data
            }, null, null, null)
        },
        ScoreInfo: function (row) {
            var args = {
                token: this.condition.token,
                oaid: row.OAID,
                oatype: 0
            }

            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadOutApplyScore', args, function (data) {
                var info = data.Data
                that.infoform.oaid = info.OAID
                that.infoform.CPStuName = info.CPStuName
                that.infoform.CPSecName = info.CPSecName

                var date = new Date(info.CPBeginDate)
                var y = date.getFullYear()
                var m = date.getMonth() + 1
                var d = date.getDate()
                var begindate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

                date = new Date(info.CPEndDate)
                y = date.getFullYear()
                m = date.getMonth() + 1
                d = date.getDate()
                var enddate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

                that.infoform.CPDate = begindate + ' - ' + enddate

                date = new Date(info.ExamDate)
                y = date.getFullYear()
                m = date.getMonth() + 1
                d = date.getDate()

                that.infoform.OutApplyDate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d) +
                    ' ' + info.ExamTimeName

                that.infoform.ProjectName = info.ProjectName

                that.infoform.outapplyscore = info.ExamScore

                if (info.DownDate != null) {
                    date = new Date(info.DownDate)
                    y = date.getFullYear()
                    m = date.getMonth() + 1
                    d = date.getDate()
                    var h = date.getHours()
                    var mm = date.getMinutes()
                    var s = date.getSeconds()
                    that.infoform.downdate = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) +
                        ' ' + (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (s < 10 ? '0' + s : s)
                }

                that.infoform.examaddress = info.ExamAddress

                that.infoform.checkstatus = info.OAStatus

                that.infoform.checkinfo = info.CheckInfo

                that.LoadOutApplyScoreTecInfo(that.infoform.oaid)
            }, null, null, null)

        },
        LoadOutApplyScoreTecInfo: function (OAID) {
            var args = {
                token: this.condition.token,
                oaid: OAID
            }

            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyTecInfo', args, function (data) {
                var list = data.Data
                for (var i = 0; i < list.length; i++) {
                    if (i == 0) {
                        that.infoform.TecName1 = list[i].TecName + '(' + list[i].TecNo + ')'
                        that.infoform.tecscore1 = list[i].Score
                    } else if (i == 1) {
                        that.infoform.TecName2 = list[i].TecName + '(' + list[i].TecNo + ')'
                        that.infoform.tecscore2 = list[i].Score
                    } else if (i == 2) {
                        that.infoform.TecName3 = list[i].TecName + '(' + list[i].TecNo + ')'
                        that.infoform.tecscore3 = list[i].Score
                    }
                }
                if (that.infoform.tecscore1 == 0 || that.infoform.tecscore2 == 0 || that.infoform.tecscore3 == 0) {
                    //三个老师没有全部打分，显示考核未完成
                    that.infoform.tecstate = 0
                } else {
                    that.infoform.tecstate = 1
                }
                that.socreInfoVisible = true
            }, null, null, null)
        },
        LoadProject: function (row) {
            var that = this
            var args = {
                token: this.form.token,
                dictid: this.$utils.DictEnum.project,
                managesec: row.CPManageSec,
                cpmanagesecname: row.CPManageSecName //管理单元
            }
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/LoadProject', args, function (data) {

                that.projectOptions = data.Data
                that.LoadOAInfo(row)
            }, null, null, null)
        },
        LoadOAInfo: function (row) {

            var args = {
                token: this.condition.token,
                oaid: row.OAID,
                oatype: 0
            }

            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadOutApplyScore', args, function (data) {
                var info = data.Data

                that.form.CPStuName = ''
                that.form.CPSecName = ''
                that.form.CPDate = ''
                that.form.TecOldID1 = ''
                that.form.TecOldID2 = ''
                that.form.TecOldID3 = ''
                that.form.TecID1 = ''
                that.form.TecID2 = ''
                that.form.TecID3 = ''
                that.form.TecName1 = ''
                that.form.TecName2 = ''
                that.form.TecName3 = ''
                that.form.tecscore1 = '0'
                that.form.tecscore2 = '0'
                that.form.tecscore3 = '0'
                that.form.projectid = ''
                that.form.OutApplyDate = ''
                that.form.outapplyscore = '0'
                that.form.downdate = ''
                that.form.oastatus = ''
                that.form.checkinfo = ''

                that.form.oaid = info.OAID
                that.form.CPStuName = info.CPStuName
                that.form.CPSecName = info.CPSecName

                var date = new Date(info.CPBeginDate)
                var y = date.getFullYear()
                var m = date.getMonth() + 1
                var d = date.getDate()
                var begindate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

                date = new Date(info.CPEndDate)
                y = date.getFullYear()
                m = date.getMonth() + 1
                d = date.getDate()
                var enddate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

                that.form.CPDate = begindate + ' - ' + enddate

                date = new Date(info.ExamDate)
                y = date.getFullYear()
                m = date.getMonth() + 1
                d = date.getDate()

                that.form.OutApplyDate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d) + ' ' + info
                    .ExamTimeName

                if (info.ExamScore != null) {
                    that.form.outapplyscore = info.ExamScore
                }

                if (info.DownDate != null) {
                    that.form.downdate = info.DownDate
                }

                that.form.projectid = info.ProjectID

                that.form.oastatus = info.OAStatus

                that.form.checkinfo = info.CheckInfo

                that.LoadOutApplyScoreTec(that.form.oaid)
            }, null, null, null)
        },
        Score: function (row) {
            this.LoadProject(row)
        },
        LoadOutApplyScoreTec: function (oaid) {
            var args = {
                token: this.condition.token,
                oaid: oaid
            }

            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyTecInfo', args, function (data) {
                var list = data.Data
                for (var i = 0; i < list.length; i++) {
                    if (i == 0) {
                        that.form.TecID1 = list[i].TecID
                        that.form.TecOldID1 = list[i].TecID
                        that.form.TecName1 = list[i].TecName + '(' + list[i].TecNo + ')'
                        if (list[i].Score != null) {
                            that.form.tecscore1 = list[i].Score
                        }
                    } else if (i == 1) {
                        that.form.TecID2 = list[i].TecID
                        that.form.TecOldID2 = list[i].TecID
                        that.form.TecName2 = list[i].TecName + '(' + list[i].TecNo + ')'
                        if (list[i].Score != null) {
                            that.form.tecscore2 = list[i].Score
                        }
                    } else if (i == 2) {
                        that.form.TecID3 = list[i].TecID
                        that.form.TecOldID3 = list[i].TecID
                        that.form.TecName3 = list[i].TecName + '(' + list[i].TecNo + ')'
                        if (list[i].Score != null) {
                            that.form.tecscore3 = list[i].Score
                        }
                    }
                }
                that.socreVisible = true
            }, null, null, null)
        },
        ScoreSave: function () {
            if (this.form.TecID1 == '') {
                this.$message({
                    message: '考官1不能为空',
                    type: 'warning'
                })
                return
            }

            if (this.form.TecID2 == '') {
                this.$message({
                    message: '考官2不能为空',
                    type: 'warning'
                })
                return
            }

            if (this.form.TecID3 == '') {
                this.$message({
                    message: '考官3不能为空',
                    type: 'warning'
                })
                return
            }

            if (this.form.TecID1 == this.form.TecID2) {
                this.$message({
                    message: '考官1 与 考官2 不能设置相同带教老师',
                    type: 'warning'
                })
                return
            }

            if (this.form.TecID1 == this.form.TecID3) {
                this.$message({
                    message: '考官1 与 考官3 不能设置相同带教老师',
                    type: 'warning'
                })
                return
            }

            if (this.form.TecID2 == this.form.TecID3) {
                this.$message({
                    message: '考官2 与 考官3 不能设置相同带教老师',
                    type: 'warning'
                })
                return
            }

            if (this.form.projectid == '') {
                this.$message({
                    message: '考核项目不能为空',
                    type: 'warning'
                })
                return
            }
            this.fullscreenLoading = true

            var that = this
            setTimeout(() => {
                this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyScore', this.form)
                    .then(res => {
                        if (res.data.Code === 0) {
                            that.$message({
                                message: '保存成功',
                                type: 'success'
                            })
                            that.handleCurrentChange(that.condition.currentPage)
                            that.socreVisible = false
                        } else {
                            that.$message({
                                message: res.data.Msg + '，' + res.data.Data,
                                type: 'error'
                            })
                        }
                        that.fullscreenLoading = false
                    })
                    .catch(err => {
                        console.log(err)
                        that.$message({
                            message: '保存失败',
                            type: 'error'
                        })
                        that.fullscreenLoading = false
                    })
            }, 100);

        },
        LoadTec: function () {
            var that = this
            var args = {
                token: this.condition.token,
                username: this.condition.username,
                rolelevel: this.condition.rolelevel,
                pageSize: 9999,
                currentPage: 1
            }
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/List', args, function (data) {
                var tecdata = data.Data
                tecdata.forEach(function (item) {
                    var arg = {
                        TecID: item.TecID,
                        TrueName: item.TrueName + '(' + item.CardNo + ')'
                    }
                    that.tecOptions.push(arg)
                })
            }, null, null, null)
        },
        Out: function () {
            this.$http.post(this.outUrl, this.condition)
                .then(res => {
                    if (res.data.Code === 0) {
                        var filename = res.data.Data
                        var url = this.$utils.Url.zpgl + '/doc/' + filename
                        window.open(url)
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$message({
                        message: '导出失败',
                        type: 'error'
                    })
                })
        }
    },
    mounted: function () {
        this.condition.token = sessionStorage.getItem('token')
        this.form.token = sessionStorage.getItem('token')
        this.delayform.token = sessionStorage.getItem('token')
        this.delayeditform.token = sessionStorage.getItem('token')
        this.condition.username = sessionStorage.getItem('username')
        this.condition.rolelevel = sessionStorage.getItem('rolelevel')

        if (this.condition.rolelevel == 3 || this.condition.rolelevel == 4 || this.condition.rolelevel == 5) {
            this.condition.outstatus = '2'
        }


        var date = new Date()
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        if (month > 12) {
            year = year + 1
            month = 1
        }
        if (month >= 1 && month <= 9) {
            month = '0' + month
        }
        this.condition.outdate = year + '-' + month
        this.LoadManageSec()
        this.LoadTec()
    }
}
</script>

<style scoped="scoped">
.message-box {
    width: 600px;
}

.timeclass {
    width: 100%;
}

::v-deep .el-table .cell {
    line-height: 25px;
}

::v-deep .el-input {
    width: 220px;
}

.el-form-item {
    margin-bottom: 5px;
}

::v-deep .el-radio {
    margin-bottom: 0;
}
</style>